<template>
  <div class="sound_big_box">
    <div class="end_tips" v-if="audioDuration && !isstop">
      点击按钮可结束录制
    </div>
    <div
      class="sound_recording_box"
      :style="{
        paddingTop: audioDuration && !isstop ? '0' : '34rem',
      }"
    >
      <!-- 左侧部分 start -->
      <div class="sound_recording_left">
        <img 
          :src="
            audioDuration && !isplay
              ? require('@/assets/images/books/book2/sound-play.png')
              : require('@/assets/images/books/book2/sound-pause.png')
          "
          alt=""
          v-if="audioDuration && isstop"
          @click.stop="recPlay"
        />
        <div
          v-if="audioDuration && isstop"
          style="text-align: center; color: #999"
        >
          {{
            isstop && !isplay ? "回放" : `时长：${audioDuration.toFixed()}s`
          }}
        </div>
      </div>
      <!-- 左侧部分 end -->
      <!-- 中间部分 start -->
      <div class="sound_recording_center">
        <img
          :src="
            audioDuration && !isstop
              ? require('@/assets/images/books/book2/sound-run.png')
              : require('@/assets/images/books/book2/sound-start.png')
          "
          alt=""
          @click.stop="recStart"
        />
        <div
          :style="{
            color: audioDuration && !isagain ? '#333333' : '#999999',
          }"
        >
          {{
            audioDuration && !isstop
              ? `录音中，时长：${audioDuration.toFixed()}s`
              : isagain
              ? "重新录音"
              : "点击开始录音"
          }}
        </div>
      </div>
      <!-- 中间部分 end -->
      <!-- 右侧部分 start -->
      <div
        class="sound_recording_right"
        :style="{
          opacity: submitD ? '0.5' : '1',
        }"
      >
        <img
          :src="require('@/assets/images/books/book2/sound-submit.png')"
          alt=""
          v-if="audioDuration && isstop"
          @click.stop="handleSubmit"
        />
        <div
          v-if="audioDuration && isstop"
          style="text-align: center; color: #999"
        >
          提交
        </div>
      </div>
      <!-- 右侧部分 end -->
    </div>
  </div>
</template>
<script>
import Recorder from "recorder-core";

// 引入mp3格式支持文件；如果需要多个格式支持，把这些格式的编码引擎js文件放到后面统统引入进来即可
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";
// 录制wav格式的用这一句就行
import "recorder-core/src/engine/wav";

export default {
  name: "sound",
  components: {},

  data() {
    return {
      localUrl: "", // 本地试听录音文件
      isSound: false, // 是否录制完成
      isStop: false, // 是否停止录制
      audioDuration: 0, //录音时长
      refName: "",

      recorder: null,
      playTime: 0,
      timer: null,
      src: null,
      isstop: false,
      isplay: false,
      isagain: false,
      submitD: false,
    };
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
    statusSound: {
      type: Boolean,
      default:false
    },
  },
  watch: {
    statusSound: {
      handler(newVal) {
         //结束录音
        if (this.audioDuration && !this.isstop && !this.isagain) {
          this.isstop = true;
          this.isagain = true; //显示重新录音
          this.rec.stop(
            (blob, duration) => {
              this.$emit("loadingTrue");
              // blob就是我们要的录音文件对象，可以上传，或者本地播放
              this.recBlob = URL.createObjectURL(blob);
              // 简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
              this.localUrl = this.recBlob;
            },
            (err) => {
              this.isSound = false;
              // this.$message.error("结束录音出错：" + err);
              this.reset("now");
            }
          );
          return;
        }
      if(this.audioDuration && this.isplay){
        this.isplay = false;
      }
        // if (this.isagain) {
        //   this.audioDuration = 0; //重新录音时重置时长和状态
        //   this.isagain = false;
        //   this.isstop = false;
        //   this.submitD = false;
        //   if (this.rec) {
        //     this.rec.close();
        //     this.rec = null;
        //     this.isStop = false;
        //     this.isSound = false;
        //   }
        // }
        // this.recorder= null;
        // this.playTime=0;
        // this.timer= null;
        // this.src=null
        // this.isstop=false
        // this.isplay=false
        // this.isagain= false
        // this.submitD= false;
        // this.audioDuration=0;
        var audioElement = document.getElementById(`${this.content.key}`)
        if (audioElement) {
          audioElement.remove();
          audioElement.pause();
        }
     
    },
},
  },
  computed: {},
  mounted() {
    this.$bus.$on('soundBus', key => {
       //结束录音
       if (this.audioDuration && !this.isstop && !this.isagain) {
        this.isstop = true;
        this.isagain = true; //显示重新录音
        this.rec.stop(
          (blob, duration) => {
            this.$emit("loadingTrue");
            // blob就是我们要的录音文件对象，可以上传，或者本地播放
            this.recBlob = URL.createObjectURL(blob);
            // 简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
            this.localUrl = this.recBlob;
          },
          (err) => {
            console.error("结束录音出错：" + err);
            this.isSound = false;
            // this.$message.error("结束录音出错：" + err);
            this.reset("now");
          }
        );
        return;
      }
    });
    this.$bus.$on('stopPlayBus',key=>{
      var audioElement = document.getElementById(`${this.content.key}`)
        if (audioElement) {
          audioElement.remove();
          audioElement.pause();
        }
        this.isplay = false;
    })
    this.$bus.$on('stopOneselfPlayBus',key=>{
      console.log(key,this.content.key)
      if(key!=this.content.key){
         var audioElement = document.getElementById(`${this.content.key}`)
        if (audioElement) {
          audioElement.remove();
          audioElement.pause();
        }
        this.isplay = false;
      }
     
    })
  },

  methods: {
    // 开始录音
    recStart() {
      //处理其他组件的播放音频暂停问题
      this.stopAllMedia();
      //结束录音
      if (this.audioDuration && !this.isstop && !this.isagain) {
        this.isstop = true;
        this.isagain = true; //显示重新录音
        this.rec.stop(
          (blob, duration) => {
            this.$emit("loadingTrue");
            // blob就是我们要的录音文件对象，可以上传，或者本地播放
            this.recBlob = URL.createObjectURL(blob);
            // 简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
            this.localUrl = this.recBlob;
          },
          (err) => {
            console.error("结束录音出错：" + err);
            this.isSound = false;
            // this.$message.error("结束录音出错：" + err);
            this.reset("now");
          }
        );
        return;
      }

      if (this.isagain) {
        this.audioDuration = 0; //重新录音时重置时长和状态

        this.isagain = false;
        this.isstop = false;
        this.submitD = false;
        if (this.rec) {
          this.rec.close();
          this.rec = null;
          this.isStop = false;
          this.isSound = false;
        }
        
      }
      //点击重新录音，判断是否有正在播放的音频，如果有则暂停，并且销毁音频标签
      this.$bus.$emit("stopPlayBus", true);

      // this.isSound = true;
      // 创建录音对象
      this.rec = Recorder({
        type: "mp3", // 录音格式，可以换成wav等其他格式
        sampleRate: 16000, // 录音的采样率，越大细节越丰富越细腻
        bitRate: 16, // 录音的比特率，越大音质越好
        onProcess: (
          buffers,
          powerLevel,
          bufferDuration,
          bufferSampleRate,
          newBufferIdx,
          asyncEnd
        ) => {
          // 录音实时回调，大约1秒调用12次本回调
          this.audioDuration = bufferDuration / 1000;
          
        },
      });

      // 打开录音，获得权限
      this.rec.open(
        () => {
          console.log("录音已打开");
          this.rec.start();
          this.$bus.$emit("soundBus", true);
          // this.$message.success("已开始录音");
        },
        (msg, isUserNotAllow) => {
          // 用户拒绝了录音权限，或者浏览器不支持录音
          this.isSound = false;
          this.$message.error('请先允许使用麦克风权限');
        }
      );
      if (!this.rec) {
        this.isSound = false;
        this.$message.error("未打开录音");
        return;
      }
    },
    // 结束录音
    recStop() {
      //结束录音
      if (this.audioDuration && !this.isstop && !this.isagain) {
        this.isstop = true;
        this.isagain = true; //显示重新录音
        this.rec.stop(
          (blob, duration) => {
            this.$emit("loadingTrue");
            // blob就是我们要的录音文件对象，可以上传，或者本地播放
            this.recBlob = URL.createObjectURL(blob);

            // 简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
            this.localUrl = this.recBlob;
            // console.log('录音成功blob', blob)
            console.log("localUrl", this.localUrl);
            // console.log('时长:' + duration + 'ms')
          },
          (err) => {
            console.error("结束录音出错：" + err);
            this.isSound = false;
            // this.$message.error("结束录音出错：" + err);
            this.reset("now");
          }
        );
        return;
      }

      if (this.isagain) {
        this.isagain = false;
        this.isstop = false;
        this.submitD = false;
        if (this.rec) {
          this.rec.destroy(); // 销毁实例，避免资源泄露
        }
      }
      // 控制频繁点击暂停录制按钮导致报错问题
      if (this.isStop) {
        return;
      }
      if (!this.rec) {
        this.isSound = false;
        this.$message.error("未打开录音");
        return;
      }
      // envInLast 录制结束时间   envInFirst 录制开始时间
      var time = this.rec.envInLast - this.rec.envInFirst;
      console.log("sound 【共录制time:", time, "ms】");
      this.isStop = true;
      this.rec.stop(
        (blob, duration) => {
          this.$emit("loadingTrue");
          // blob就是我们要的录音文件对象，可以上传，或者本地播放
          this.recBlob = URL.createObjectURL(blob);

          // 简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
          this.localUrl = this.recBlob;
          // console.log('录音成功blob', blob)
          console.log("localUrl", this.localUrl);
          // console.log('时长:' + duration + 'ms')
        },
        (err) => {
          console.error("结束录音出错：" + err);
          this.isSound = false;
          // this.$message.error("结束录音出错：" + err);
          this.reset("now");
        }
      );
    },
    // 本地试听
    recPlay() {
      if (!this.isplay) {
        this.isplay = true;
        try {
          var audioData = this.recBlob;
          if (audioData) {
            // 创建audio元素并设置属性
            var audio = this.createAudioElement(audioData);

            // 播放音频
            audio.play().catch((error) => {
              console.error("播放录音时出错：", error);
              this.$message.error(
                "播放录音失败，请确保在用户的交互操作下播放。"
              );
            });

            // 监听音频播放结束事件
            audio.addEventListener("ended", () => {
              this.isplay = false;
              console.log(audio.src, "audio.src结束了。。。。。。。");
              // URL.revokeObjectURL(audio.src);
              this.removeAudioElement(audio); // 从DOM中移除audio元素
            });

            // 更新音频时长显示
            // this.audioDuration = audioData.duration;
          } else {
            console.error("未找到录音数据");
          }
        } catch (error) {
          console.error("处理录音播放时出错：", error);
        }
        //点击重新录音，判断是否有正在播放的音频，如果有则暂停，并且销毁音频标签,排除自身音频标签

        this.$bus.$emit("stopOneselfPlayBus", this.content.key);
        this.$bus.$emit("soundBus", true);
      } else {
        // 移除当前组件中audio元素并停止播放
        var audioElement = document.getElementById(`${this.content.key}`)
        if (audioElement) {
          audioElement.remove();
          audioElement.pause();
        }
        this.isplay = false;
        
      }
      //处理其他组件的播放音频暂停问题
      this.stopAllMedia();
    },
    stopAllMedia() {
      // 获取页面上所有的audio和video元素
      const audios = document.getElementsByTagName('audio');
      const videos = document.getElementsByTagName('video');

      // 停止所有的audio元素
      // for (let i = 0; i < audios.length; i++) {
      //   if (!audios[i].paused) {
      //     audios[i].pause();
      //   }
      // }
      // for (let i = 0; i < audios.length; i++) {
      //   // 检查当前audio元素的id是否不是要排除的id
      //   if (!audios[i].id.includes('.') && audios[i].id !== this.content.key && !audios[i].paused) {
      //     // 停止播放
      //     audios[i].pause();
      //   }
      // }
      // 停止所有的video元素
      for (let i = 0; i < videos.length; i++) {
        if (!videos[i].paused) {
          videos[i].pause();
        }
      }
    },
    // 创建audio元素并添加到DOM中
    createAudioElement(src) {
      var audio = document.createElement("audio");
      audio.id = this.content.key;
      audio.controls = true;
      audio.src = src;
      audio.style.display = "none";
      document.getElementsByClassName('sound_big_box')[0].appendChild(audio);
      return audio;
    },

    // 从DOM中移除audio元素
    removeAudioElement(audio) {
      if (audio && audio.parentNode) {
        audio.parentNode.removeChild(audio);
      }
    },
    // recPlay() {
    //   try {
    //     // 从localStorage获取录音数据
    //     var audioData = JSON.parse(localStorage.getItem(this.refName));
    //     if (audioData) {
    //       // 创建audio元素并设置属性
    //       var audio = document.createElement("audio");
    //       audio.controls = true;
    //       document.body.appendChild(audio);

    //       // 直接使用存储的URL设置audio的src
    //       audio.src = audioData.src;

    //       // 播放音频
    //       audio.play()
    //         audio.addEventListener('ended', () => {
    //           console.log(audio.src,'audio.src结束了。。。。。。。')
    //           URL.revokeObjectURL(audio.src);
    //         });
    //       // 更新音频时长显示
    //       this.audioDuration = audioData.duration;
    //     } else {
    //       console.error("未找到录音数据");
    //     }
    //   } catch (error) {
    //     console.error("处理录音播放时出错：", error);
    //   }
    // },
    // 重置
    handleSubmit() {
      this.$message({
        message: "提交成功",
        type: "success",
      });
      this.submitD = true;
      this.$bus.$emit("stopPlayBus", true);
    },
    reset(type) {
      // 如果类型未指定，则不需要清除特定状态（如toast），直接进行录音资源的重置
      if (this.rec) {
        // 关闭录音并释放相关资源
        this.rec.close();
        // 重置录音对象和状态标志
        this.rec = null;
        this.isStop = false;
        this.isSound = false;
        // 可以在此处添加其他需要的重置逻辑
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.sound_big_box {
  background: #fff;
  min-height: 200rem;
}
.sound_recording_box {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.sound_recording_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 100rem;
  img {
    width: 88rem;
    height: 88rem;
    cursor: pointer;
  }
  p {
    margin-top: 20rem;
    color: #999999;
    font-size: 26rem;
  }
}
.sound_recording_left {
  text-align: center;
}
.sound_recording_left img,
.sound_recording_right img {
  width: 61rem;
  height: 61rem;
  cursor: pointer;
}
.end_tips {
  text-align: center;
  color: #999999;
  font-size: 20rem;
  padding-top: 12rem;
  font-family: STXihei;
}
</style>